/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-10 16:39:54
 * @FilePath: /app-monorepo-projects/packages/app-share/src/store/mutation-types.ts
 */
enum MutationTypes {
  SET_SHOW_COLLECTION = 'SET_SHOW_COLLECTION',
  SET_IS_COLLECTION = 'SET_IS_COLLECTION',
  SET_IS_DRAMA = 'SET_IS_DRAMA',
  SET_IS_NEWUI = 'SET_IS_NEWUI',
  SET_ACTIVE_PLAYER_PLAYING = 'SET_ACTIVE_PLAYER_PLAYING',
  SET_COLLECTION_INFO = 'SET_COLLECTION_INFO',
  SET_FEEDS_LIST = 'SET_FEEDS_LIST',
  SET_ACTIVE_INDEX = 'SET_ACTIVE_INDEX',
  SET_GROWTHTEST_DATA = 'SET_GROWTHTEST_DATA',
  SET_SHARE_UI = 'SET_SHARE_UI',
  SET_BANNER = 'SET_BANNER',
  SET_ERROR_MSG = 'SET_ERROR_MSG',
  INITIALIZE_COLLECTION_DATA = 'INITIALIZE_COLLECTION_DATA',  // 初始化精选集数据
  SET_GROWTH_POPUP = 'SET_GROWTH_POPUP', // 设置号码包试验控制的拉新拉活弹窗开关
  SET_DRAMA_LIST = 'SET_DRAMA_LIST',
  SET_SHOW_HAND_TIP = 'SET_SHOW_HAND_TIP',
  SET_IS_FULL_SCREEN = 'SET_IS_FULL_SCREEN',
  SET_IS_NEW_PAGE = 'SET_IS_NEW_PAGE',
  SET_IS_WS_INSTALLED = 'SET_IS_WS_INSTALLED',
}

export default MutationTypes;
